__turbopack_context__.v({
  "className": "noedisplayregular_4544156b-module__HUfC_W__className",
  "variable": "noedisplayregular_4544156b-module__HUfC_W__variable",
});
